import React, { lazy, Suspense } from "react";
import componentLoader from "../../utilities/componentLoader";

const Dashboard = lazy(() =>
  componentLoader(() => import("./components/Dashboard")),
);

export default () => (
  <div>
    <Suspense fallback={<div />}>
      <section>
        <Dashboard />
      </section>
    </Suspense>
  </div>
);
